// 模块标题
export const moduleTitleRules = {
  fontFamily: 'var(--title2-family)',
  themeId: 3,
  diannao: {
    fontSize: 'var(--title2-pc-size)',
    fontSizeUnit: 'px',
    letterSpacing: 'var(--title2-pc-letter-spacing)',
    letterSpacingUnit: 'px',
    lineHeight: 40
  },
  pingban: {
    fontSize: 'var(--title2-pad-size)',
    letterSpacing: 'var(--title2-pad-letter-spacing)',
    lineHeight: 32
  },
  shouji: {
    fontSize: 'var(--title2-phone-size)',
    letterSpacing: 'var(--title2-phone-letter-spacing)',
    lineHeight: 30
  }
}

// 列表标题
export const listTitleRules = {
  fontFamily: 'var(--title4-family)',
  themeId: 5,
  diannao: {
    fontSize: 'var(--title4-pc-size)',
    letterSpacing: 'var(--title4-pc-letter-spacing)',
    lineHeight: 28
  },
  pingban: {
    fontSize: 'var(--title4-pad-size)',
    letterSpacing: 'var(--title4-pad-letter-spacing)',
    lineHeight: 24
  },
  shouji: {
    fontSize: 'var(--title4-phone-size)',
    letterSpacing: 'var(--title4-phone-letter-spacing)',
    lineHeight: 22
  }
}

// 段落
export const paragraphRules = {
  fontFamily: 'var(--content-family)',
  themeId: 6,
  diannao: {
    fontSize: 'var(--content-pc-size)',
    letterSpacing: 'var(--content-pc-letter-spacing)',
    lineHeight: 24
  },
  pingban: {
    fontSize: 'var(--content-pad-size)',
    letterSpacing: 'var(--content-pad-letter-spacing)',
    lineHeight: 24
  },
  shouji: {
    fontSize: 'var(--content-phone-size)',
    letterSpacing: 'var(--content-phone-letter-spacing)',
    lineHeight: 20
  }
}

// 轮播按钮大小
export const buttonSizeRules = {
  diannao: {
    width: 36
  },
  pingban: {
    width: 30
  },
  shouji: {
    width: 28
  }
}
//详情页文字大小
export const detailRules = {
  fontFamily: 'var(--title3-family)',
  themeId: 4,
  diannao: {
    fontSize: 'var(--title3-pc-size)',
    lineHeight: 30,
    letterSpacing: 'var(--title3-pc-letter-spacing)'
  },
  pingban: {
    fontSize: 'var(--title3-pad-size)',
    lineHeight: 28,
    letterSpacing: 'var(--title3-pad-letter-spacing)'
  },
  shouji: {
    fontSize: 'var(--title3-phone-size)',
    lineHeight: 24,
    letterSpacing: 'var(--title3-phone-letter-spacing)'
  }
}
//文字按钮 图标按钮
export const textButtonRules = {
  fontFamily: 'var(--content-family)',
  themeId: 6,
  diannao: {
    width: 160,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 18,
    paddingRight: 18,
    fontSize: 'var(--content-pc-size)',
    letterSpacing: 'var(--content-pc-letter-spacing)'
  },
  pingban: {
    width: 120,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 'var(--content-pad-size)',
    letterSpacing: 'var(--content-pad-letter-spacing)'
  },
  shouji: {
    width: 120,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 'var(--content-phone-size)',
    letterSpacing: 'var(--content-phone-letter-spacing)'
  }
}
export const textIconButtonRules = {
  fontFamily: 'var(--content-family)',
  themeId: 6,
  diannao: {
    width: 160,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 18,
    paddingRight: 18,
    fontSize: 'var(--content-pc-size)',
    letterSpacing: 'var(--content-pc-letter-spacing)'
  },
  pingban: {
    width: 150,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: 'var(--content-pad-size)',
    letterSpacing: 'var(--content-pad-letter-spacing)'
  },
  shouji: {
    width: 140,
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 'var(--content-phone-size)',
    letterSpacing: 'var(--content-phone-letter-spacing)'
  }
}

export const subtitleTitleRules = {
  fontFamily: 'var(--subtitle-family)',
  themeId: 2,
  diannao: {
    fontSize: 'var(--subtitle-pc-size)',
    lineHeight: 30,
    letterSpacing: 'var(--subtitle-pc-letter-spacing)'
  },
  pingban: {
    fontSize: 'var(--subtitle-pc-size)',
    lineHeight: 28,
    letterSpacing: 'var(--subtitle-pc-letter-spacing)'
  },
  shouji: {
    fontSize: 'var(--subtitle-pc-size)',
    lineHeight: 24,
    letterSpacing: 'var(--subtitle-pc-letter-spacing)'
  }
}
//面包屑
export const crumbsRules = {
  diannao: {
    fontSize: 16,
    lineHeight: 26,
    paddingTB: 10
  },
  pingban: {
    fontSize: 16,
    lineHeight: 24,
    paddingTB: 8
  },
  shouji: {
    fontSize: 14,
    lineHeight: 20,
    paddingTB: 6
  }
}

//带标题面包屑
export const titleCrumbsRules = {
  diannao: {
    fontSize: 18,
    lineHeight: 24,
    paddingTop: 10,
    paddingBottom:20,
    titleFontSize: 26,
    titleLineHeight: 34,
    titlePaddingTB: 30
  },
  pingban: {
    fontSize: 16,
    lineHeight: 24,
    paddingTop: 10,
    paddingBottom:20,
    titleFontSize: 24,
    titleLineHeight: 32,
    titlePaddingTB: 20
  },
  shouji: {
    fontSize: 14,
    lineHeight: 22,
    paddingTop: 0,
    paddingBottom:10,
    titleFontSize: 20,
    titleLineHeight: 30,
    titlePaddingTB: 10
  }
}
